var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{ name: 'profile', params: { slug: _vm.user.slug }},"qid":"user-dropdown-profile-link"}},[_vm._v("\n  "+_vm._s(_vm.user.name)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }